import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({ name: 'bnEsDate' })
export class BnEsDatePipe implements PipeTransform {
  constructor(private date: DatePipe) {}

  transform(value: string, empty: string = '--'): string {
    if (!value || +value === -1) {
      return empty;
    }

    if (value.indexOf('T') !== -1) {
      const cleanDate = value.split('T')[0];
      const dateArr = cleanDate.split('-');
      value = `${dateArr[2]}-${dateArr[1]}-${dateArr[0]}`;
    }

    const dateArray = value.split('-');
    const calculatedDate = new Date(+dateArray[2], +dateArray[1] - 1, +dateArray[0]);
    return `${this.date.transform(calculatedDate, 'mediumDate')}`;
  }
}
